import { cn } from "@omni/utils/styles";

type FeatureKindComponentProps = {
    sectionName: string;
    closed: boolean;
    width: number;
    toggleSection: (sectionName: string) => void;
};

const FeatureKindComponent = ({
    sectionName,
    closed,
    width,
    toggleSection
}: FeatureKindComponentProps) => {
    const handleOnClick = () => toggleSection(sectionName);

    return (
        <div
            className={cn("tw:absolute tw:h-12 tw:mt-4")}
            style={{
                width: `${width}px`
            }}
        >
            <div
                className={cn(
                    "tw:cursor-pointer tw:flex tw:justify-between tw:items-center tw:h-full tw:border-b tw:border-b-primary tw:font-bold"
                )}
                onClick={handleOnClick}
            >
                <span>{sectionName}</span>
                <i
                    className={cn(
                        {
                            "las la-plus": closed,
                            "las la-minus": !closed
                        },
                        "tw:flex tw:items-center"
                    )}
                ></i>
            </div>
        </div>
    );
};

export { FeatureKindComponent };
